import React from "react";

const LeftAlignSvg = ({ fill, width = 14, height = 14,selected }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 14"
      fill={selected ? "#0072C6" : "white"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 0H1V14H0V0Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 5H5V9H2V5Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 5H9V9H6V5Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 5H13V9H10V5Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14 5H17V9H14V5Z"
        fill={selected ? "white" : "black"}
      />
    </svg>
  );
};

export default LeftAlignSvg;
